import { render, staticRenderFns } from "./navbarinfo.vue?vue&type=template&id=6cfdd2b0&scoped=true"
import script from "./navbarinfo.vue?vue&type=script&lang=js"
export * from "./navbarinfo.vue?vue&type=script&lang=js"
import style0 from "./navbarinfo.vue?vue&type=style&index=0&id=6cfdd2b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfdd2b0",
  null
  
)

export default component.exports